import { render, staticRenderFns } from "./Library.vue?vue&type=template&id=04a9187d&scoped=true"
import script from "./Library.vue?vue&type=script&lang=js"
export * from "./Library.vue?vue&type=script&lang=js"
import style0 from "./Library.vue?vue&type=style&index=0&id=04a9187d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a9187d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a9187d')) {
      api.createRecord('04a9187d', component.options)
    } else {
      api.reload('04a9187d', component.options)
    }
    module.hot.accept("./Library.vue?vue&type=template&id=04a9187d&scoped=true", function () {
      api.rerender('04a9187d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/sidebar/Library.vue"
export default component.exports